import { Button, Typography } from '@material-ui/core';
import { NavigateNext as NavigateNextIcon } from '@material-ui/icons';
import { connect as formikConnect } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { path, pathOr } from '../../../../../../utils';
import { useCompleteOrderStyles } from './styles';

const getTotalPrice = (product, bags) => {
  const { price, freeBagsIncluded, additionalBagsPrice } = product;
  return price + (bags - freeBagsIncluded) * additionalBagsPrice;
};

const formatPrice = price => `€${price.toLocaleString('es-ES', { minimumFractionDigits: 2 })}`;

const CompleteButton = ({ formik: { values, submitCount, isValid } }) => {
  const classes = useCompleteOrderStyles();
  const flightProducts = useSelector(state => state.flightProducts);
  const flightSelected = path('flightSelected', values);
  const serviceType = path('service.type', values);
  const numBags = path('service.numBags', values);
  const products = pathOr([], `data.${flightSelected}.products`, flightProducts);

  if (!flightSelected || !serviceType || !products.length) {
    return null;
  }

  const { product } = products.find(({ service }) => service === serviceType);
  const totalPrice = formatPrice(getTotalPrice(product, numBags));

  return (
    <div className={classes.root}>
      <div className={classes.priceContainer}>
        <Typography variant="body1">Total</Typography>
        <Typography variant="h5" component="p">
          {totalPrice}
        </Typography>
      </div>
      <Button
        data-testid="btn.pre-create-order"
        type="submit"
        color="primary"
        variant="contained"
        disabled={submitCount && !isValid}
        startIcon={<NavigateNextIcon />}
      >
        Create order
      </Button>
    </div>
  );
};

CompleteButton.propTypes = {
  formik: PropTypes.shape({
    values     : PropTypes.objectOf(PropTypes.any).isRequired,
    submitCount: PropTypes.number.isRequired,
    isValid    : PropTypes.bool.isRequired,
  }).isRequired,
};

export default formikConnect(CompleteButton);
